'use strict';

var Chart = require('chart.js');

Chart = typeof Chart === 'function' ? Chart : window.Chart;
var y = null;
var x = null;
var isDrawing = {};
var labelElement = null;
var dataPoints = [];

var drawCrosshairAtPoint = function drawCrosshairAtPoint(chart, dataPoints) {
  var x = 0;
  dataPoints.map(function (point) {
    x = x + point.x;
  });
  x = Math.ceil(x / dataPoints.length);

  if (x < Math.floor(chart.chartArea.left) || Math.floor(x) > chart.chartArea.right) {
    return;
  }

  var canvas = chart.canvas;
  var context = canvas.getContext('2d');
  context.beginPath();
  context.moveTo(x, chart.chartArea.top);
  context.lineTo(x, chart.chartArea.bottom);
  context.strokeStyle = 'rgba(246, 128, 199, 1)';
  context.stroke();
  context.closePath();
  dataPoints.map(function (point) {
    drawPoint({
      context: context,
      x: point.x,
      y: point.y
    });
  });
};

var drawPoint = function drawPoint(_ref) {
  var context = _ref.context,
      x = _ref.x,
      y = _ref.y;
  context.beginPath();
  context.arc(x, y, 2, 0, 2 * Math.PI, false);
  context.fillStyle = '#fff';
  context.fill();
  context.lineWidth = 1;
  context.strokeStyle = 'rgba(246, 128, 199, 1)';
  context.stroke();
  context.beginPath();
  context.arc(x, y, 6, 0, 2 * Math.PI, false);
  context.lineWidth = 1;
  context.strokeStyle = 'rgba(246, 128, 199, 0.5)';
  context.stroke();
};

var CrosshairPlugin = function CrosshairPlugin(callback) {
  return {
    x: null,
    y: y,
    callback: callback,
    afterEvent: function afterEvent(targetChart, e) {
      if (e.type !== 'mousemove') {
        isDrawing[targetChart.options.id] = false;
        return;
      }

      labelElement = document.getElementById('label-' + targetChart.options.id);
      var elem = targetChart.getElementsAtEventForMode(e, 'nearest', {
        intersect: false
      })[0];

      if (elem !== undefined) {
        dataPoints = JSON.parse(labelElement.getAttribute('data-coordinates'));
        isDrawing[targetChart.options.id] = true;
      }
    },
    afterDraw: function afterDraw(targetChart) {
      isDrawing[targetChart.options.id] && drawCrosshairAtPoint(targetChart, dataPoints);
    }
  };
};

module.exports = CrosshairPlugin;
Chart.pluginService.register(CrosshairPlugin());